function Footer() {
  return (
    <footer className="max-w-6xl mx-4 md:mx-auto mt-14 pb-8 text-sm text-slate-600">
      <div className="glass-card px-4 md:px-6 py-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <p>© {new Date().getFullYear()} Marko Piljak. Alle Rechte vorbehalten.</p>

        <nav className="flex items-center gap-4 md:gap-6">
          <a href="/impressum" className="hover:text-cyan-700 transition-colors">Impressum</a>
          <a href="/datenschutz" className="hover:text-cyan-700 transition-colors">Datenschutz</a>
          <a href="/#contact" className="hover:text-cyan-700 transition-colors">Kontakt</a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
